module.exports = __webpack_public_path__ + "uturn.svg?7618f3805a1363f4d94b3ed40d0f4555";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/uturn.svg
// module id = 232
// module chunks = 0